export const ERROR_EMAIL = 'info@allegrow.co';
export const HELP_EMAIL = 'hello@neverspam.io';